<template>
    <div>
        <div v-if="integration.integrationStatus == 0 || integration.integrationStatus == 4" class="px-5 pt-4 d-flex flex-column">
            <request-activation :integration="integration" @close="close()" />
        </div>

        <div v-else-if="integration.integrationStatus == 1" class="px-5 pt-4 d-flex flex-column">
            <activated :integration="integration" @close="close()" />
        </div>

        <div v-else-if="integration.integrationStatus == 2" class="px-5 pt-4 d-flex flex-column">
            <pending-activation @close="close()" />
        </div>

        <div v-else-if="integration.integrationStatus == 3" class="px-5 pt-4 d-flex flex-column">
            <pending-deactivation @close="close()" />
        </div>
    </div>
</template>

<script>
    import requestActivation from './stateLabelArea/requestActivation'
    import activated from './stateLabelArea/activated'
    import pendingActivation from './stateLabelArea/pendingActivation'
    import pendingDeactivation from './stateLabelArea/pendingDeactivation'

    export default {
        props: {
            integration: {
                type: Object,
                required: true
            }
        },
        components: {
            requestActivation,
            activated,
            pendingActivation,
            pendingDeactivation
        },
        methods: {
            close() {
                this.$emit('close');
            }
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// stateLabel.vue?3197d5b4